import { useState, type ReactElement } from 'react';

import { useSession } from '../../access/session';
import { apiUrl } from '../../lib/build';
import { useSettings } from '../../store/settings';
import type { Meta } from '../../next/meta';
import { remember, remembered, reportBody } from '../../next/report';
import { reportHref } from '../../next/route';
import type { FeedRow } from '../../next/rows';
import { useShow } from '../../next/show';

/** Запись плана в «мою статистику». Касса снята. */
export function CaptureButton({
  row,
  meta,
}: {
  row: FeedRow;
  meta: Meta;
}): ReactElement {
  const logged = useSession((s) => s.me.id);
  const fx = useSettings((s) => s.fx);
  const unit = useShow((s) => s.unit);
  const body = reportBody(row, meta, fx, unit);
  const [state, setState] = useState<'idle' | 'work' | 'done' | 'err'>(
    body !== null && remembered(body.forkId) ? 'done' : 'idle',
  );
  if (!logged || body === null) {
    return <span className="nx-calc__capture" />;
  }
  const send = (): void => {
    if (state === 'work' || state === 'done') return;
    setState('work');
    void fetch(apiUrl('/v1/reports'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok) {
          setState('err');
          return;
        }
        remember(body.forkId);
        setState('done');
      })
      .catch(() => setState('err'));
  };
  return (
    <span className="nx-calc__capture">
      {state === 'done' ? (
        <a className="nx-calc__tool" href={reportHref()}>
          в статистике ↗
        </a>
      ) : (
        <button type="button" className="nx-calc__tool" onClick={send} disabled={state === 'work'}>
          {state === 'work' ? 'записываю' : state === 'err' ? 'не записалось, ещё раз' : 'в статистику'}
        </button>
      )}
    </span>
  );
}
